"use client";

import { forwardRef } from "react";
import { AtcMobileDrawer } from "./atc-mobile-drawer";
import { AtcAccordion } from "@/components/meds/atc/atc-list/atc-accordion/atc-accordion";
import { AtcSearchBar } from "./atc-search-bar";
import { AtcViewModeDropdown } from "./atc-view-mode-dropdown";

interface AtcMobileControlsProps {
  items: AtcItem[];
  selectedAtc: AtcItem | null;
  drawerOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onLeafSelect: () => void;
  onSelect: (item: AtcItem) => void;
  initialExpandedIds: Set<string>;
  search: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
  compactView: boolean;
  onCompactViewChange: (compact: boolean) => void;
}

export const AtcMobileControls = forwardRef<
  HTMLInputElement,
  AtcMobileControlsProps
>(
  (
    {
      items,
      selectedAtc,
      drawerOpen,
      onOpenChange,
      onLeafSelect,
      onSelect,
      initialExpandedIds,
      search,
      onSearchChange,
      onClearSearch,
      compactView,
      onCompactViewChange,
    },
    ref,
  ) => {
    return (
      <div className="mb-4 flex flex-col gap-2 lg:hidden">
        <h2 className="mb-1 text-lg font-semibold">Klasyfikacja leków</h2>
        <AtcMobileDrawer
          open={drawerOpen}
          onOpenChange={onOpenChange}
          selectedAtc={selectedAtc}
        >
          <AtcAccordion
            items={items}
            onSelect={onSelect}
            onLeafSelect={onLeafSelect}
            initialExpandedIds={initialExpandedIds}
          />
        </AtcMobileDrawer>
        <div className="flex items-stretch gap-2">
          <div className="flex-1">
            <AtcSearchBar
              ref={ref}
              value={search}
              onChange={onSearchChange}
              onClear={onClearSearch}
            />
          </div>
          <AtcViewModeDropdown
            compactView={compactView}
            onCompactViewChange={onCompactViewChange}
          />
        </div>
      </div>
    );
  },
);

AtcMobileControls.displayName = "AtcMobileControls";
